'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
/**
 *
 * @class
 */

export default class CssClassData extends ImmutableModel {
  /**
   * @constructor
   */
  constructor(props) {
    return super(props);
  }

}
CssClassData.REQUIRED_FIELDS = ['order', 'classes'];